import { gql } from '@apollo/client';

export function getPersonDetailsInfo() {
  return gql`
    query getPersonDetailsInfo($id: String!) {
      salesforce {
        getPersonDetails(id: $id) {
          introducedBy {
            id
            fullName
          }
          mainBusinessPartner {
            personId
            fullName
          }
          regenerateKYC
          category
          businessPartner {
            auxiliaryAccount
            code
            createdBy
            createdOn
            fullName
            hasAccessToAllInsured
            id
            isCompany
            isLocal
            isRegistered
            maxCreditLimitAllowed
            maxCreditLimitAllowedCurrency
            modifiedBy
            modifiedOn
            personId
            registerationExpiryDate
            registerationNumber
            relatedCompany
            status
            taxAuxiliaryAccount
            totalCreditLimitReached
            type
          }
          cityOfBirth
          civilRegisterNumber
          civilRegisterPlace
          code
          comments
          companyName
          countryOfBirth
          createdBy
          createdOn
          dateOfBirth
          dateOfDeath
          dateOfDeathNotified
          dateOfEmployment
          dateOfKYC
          dateOfSelfCertificateReceived
          dateOfSelfCertificateValidated
          email
          employer
          fatherName
          financialReference
          firstName
          fullName
          gender
          height
          id
          initials
          isTaxable
          lastName
          maidenName
          managerName
          maritalStatus
          middleName
          modifiedBy
          modifiedOn
          motherName
          occupationClass
          passportNumber
          profession
          professionEntity {
            description
            id
          }
          registrationDate
          registrationPlace
          relation
          relativeOf
          relative {
            fullName
          }
          remarks
          salary
          smoker
          spouseFullName
          spouseProfession
          status
          taxResidenceCountry
          title
          type
          userId
          weight
          phoneDetails {
            phoneType
            phoneNumber
          }
          legalRepresentative {
            fullName
            dateOfBirth
            nationality
          }
          firstNationality {
            id
            code
            title
          }
          secondNationality {
            id
            code
            title
          }
          user {
            code
          }
          occupation {
            id
            code
            title
          }
          personTaxResidenceCountry {
            id
            code
            title
          }
          registrationPlaceCountry {
            code
            id
            title
          }
          legalRepresentativeNationality {
            id
            code
            title
          }
          personTitle {
            id
            code
            title
          }
          nationalityId
          placeOfBirthCountry {
            code
            createdOn
            id
            modifiedOn
            title
          }
        }
        getProviderByPersonId(personId: $id) {
          providerCode
          id
        }
      }
    }
  `;
}

export function getPersonAddressDetails() {
  return gql`
    query getPersonAddressDetails($personAddressId: String!) {
      salesforce {
        getPersonAddressDetails(personAddressId: $personAddressId) {
          addressType
          createdBy
          createdOn
          id
          isPrimary
          modifiedBy
          modifiedOn
          personId
          status
          address {
            addressDetails
            addressDetailsArabic
            building
            city
            country
            street
            zone
          }
        }
      }
    }
  `;
}

export const getEntityAuditTrailsQuery = gql`
  query getEntityAuditTrails($id: String!) {
    core {
      getEntityAuditTrails(id: $id) {
        createdBy
        createdOn
        entityId
        id
        modifiedBy
        message
        modifiedOn
        title
        type
      }
    }
  }
`;

export function getPersonDetailsAddressList() {
  return gql`
    query getPersonDetailsAddressList(
      $personId: String!
      $currentPage: Int!
      $currentPageSize: Int!
      $Attribute: String!
      $Descending: Boolean!
    ) {
      salesforce {
        getPersonAddressList(
          personId: $personId
          pagination: { pageNumber: $currentPage, pageSize: $currentPageSize }
          orderBy: { attribute: $Attribute, descending: $Descending }
        ) {
          paging {
            pageSize
            pageNumber
            totalCount
          }
          items {
            addressType
            createdBy
            createdOn
            id
            isPrimary
            modifiedBy
            modifiedOn
            personId
            status
            address {
              addressDetails
              addressDetailsArabic
              building
              city
              country
              street
              zone
            }
            country {
              code
              id
              title
            }
            zone {
              code
              id
              title
            }
          }
        }
      }
    }
  `;
}

export function getPersonPartnersList() {
  return gql`
    query getPersonPartnersList(
      $currentPage: Int!
      $currentPageSize: Int!
      $personId: String!
      $Attribute: String!
      $Descending: Boolean!
      $keywordSearch: String
    ) {
      salesforce {
        getPersonPartnersList(
          keyword: $keywordSearch
          orderBy: { attribute: $Attribute, descending: $Descending }
          pagination: { pageNumber: $currentPage, pageSize: $currentPageSize }
          personId: $personId
        ) {
          paging {
            pageNumber
            pageSize
            totalCount
          }
          items {
            createdBy
            createdOn
            dateOfBirth
            id
            modifiedBy
            modifiedOn
            name
            nationality
            nationalities {
              id
              code
              title
            }
            personId
            sharePercentage
          }
        }
      }
    }
  `;
}

export function getPersonAuthorizedSignatoryList() {
  return gql`
    query getPersonAuthorizedSignatoryList(
      $currentPage: Int!
      $currentPageSize: Int!
      $personId: String!
      $Attribute: String!
      $Descending: Boolean!
      $keywordSearch: String
    ) {
      salesforce {
        getPersonAuthorizedSignatoryList(
          pagination: { pageNumber: $currentPage, pageSize: $currentPageSize }
          orderBy: { attribute: $Attribute, descending: $Descending }
          personId: $personId
          keyword: $keywordSearch
        ) {
          paging {
            pageSize
            pageNumber
            totalCount
          }
          items {
            createdBy
            createdOn
            dateOfBirth
            id
            modifiedBy
            modifiedOn
            name
            nationality
            personId
            nationalities {
              id
              code
              title
            }
          }
        }
      }
    }
  `;
}

export function activatePerson() {
  return gql`
    mutation activatePerson($personId: String!) {
      salesforce {
        activatePerson(personId: $personId)
      }
    }
  `;
}

export function deactivatePerson() {
  return gql`
    mutation deactivatePerson($personId: String!) {
      salesforce {
        deactivatePerson(personId: $personId)
      }
    }
  `;
}

export function activatePersonAddress() {
  return gql`
    mutation activatePersonAddress(
      $personId: String!
      $personAddresses: [String!]!
    ) {
      salesforce {
        activatePersonAddress(
          personId: $personId
          personAddresses: $personAddresses
        )
      }
    }
  `;
}

export function deactivatePersonAddress() {
  return gql`
    mutation deactivatePersonAddress(
      $personAddresses: [String!]!
      $personId: String!
    ) {
      salesforce {
        deactivatePersonAddress(
          personAddresses: $personAddresses
          personId: $personId
        )
      }
    }
  `;
}

export function deletePersonPartner() {
  return gql`
    mutation deletePersonPartner($ids: [String!]!) {
      salesforce {
        deletePersonPartner(ids: $ids)
      }
    }
  `;
}

export function deleteAuthorizedSignatory() {
  return gql`
    mutation deleteAuthorizedSignatory($ids: [String!]!) {
      salesforce {
        deleteAuthorizedSignatories(ids: $ids)
      }
    }
  `;
}

export const uploadPersonDocument = gql`
  mutation uploadPersonDocument(
    $document: Upload!
    $documentName: String!
    $personID: String!
  ) {
    salesforce {
      uploadPersonDocument(
        document: $document
        documentName: $documentName
        personID: $personID
      )
    }
  }
`;

export const getPersonDocuments = gql`
  query getPersonDocuments($personID: String!) {
    salesforce {
      getPersonDocuments(personID: $personID) {
        createdOn
        documentId
        documentName
        fileName
        version
      }
    }
  }
`;

export const getPersonAdditionalDocuments = gql`
  query getPersonAdditionalDocuments($personID: String!) {
    salesforce {
      getPersonAdditionalDocuments(personID: $personID) {
        createdOn
        documentId
        documentName
        fileName
        version
      }
    }
  }
`;

export const generateKYCMutation = gql`
  mutation generateKYC($personID: String!) {
    salesforce {
      generateKYC(personID: $personID)
    }
  }
`;
